// ─── Notification choices — the « Notifications » screen's API (2026-10-01) ──
//
// Plan docs/superpowers/plans/2026-10-01-pwa-push.md, piece 4. For each alert
// type the owner picks how it reaches him: push, WhatsApp, both, or the bell
// only. One choice per user per type, saved by the worker (routes/push.ts).
//
// ⚠️ A FILE OF ITS OWN ON PURPOSE. Piece 3 adds `pushApi` (key / subscribe /
// test…) to lib/api.ts at the same time; keeping these two calls here means
// the two pieces never edit the same lines. `prefs` and `setPref` carry the
// same names the plan gives them inside `pushApi`, so folding this file into
// it later is a rename, nothing more.
import { apiFetch } from './api';

/** Mirrors worker lib/pushRouting.ts `AlertGroup`. */
export type AlertGroup = 'reply' | 'now' | 'system' | 'info';
/** Mirrors worker lib/pushRouting.ts `Channel`. */
export type Channel = 'push' | 'whatsapp' | 'both' | 'bell';

/** One alert type as GET /push/prefs returns it, with this user's choice. */
export interface PushPrefKind {
  kind: string;
  /** English, from the worker's ALERT_KINDS. */
  label: string;
  group: AlertGroup;
  channel: Channel;
  isDefault: boolean;
}

export const pushPrefsApi = {
  /** Every alert type, with the signed-in user's choice (or the default). */
  prefs: () => apiFetch<{ kinds: PushPrefKind[] }>('/push/prefs'),
  /** Save one choice for the signed-in user. Rejects when the worker refuses. */
  setPref: (kind: string, channel: Channel) =>
    apiFetch<{ ok?: boolean }>('/push/prefs', {
      method: 'PUT',
      body: JSON.stringify({ kind, channel }),
    }),
};
